import { select } from "@angular-redux/store";
import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";
import { ContainerReleaseStatus } from "../../../pb-screen/models/pb-screen.interface";
import { ComponentSource } from "../../models/component-source";
import { HasConflicts } from "../../models/planning-conflict";

@Component({
  selector: "depot-action-icons",
  templateUrl: "action-icons.component.html",
})

export class ActionIconsComponent implements OnInit, OnChanges {
  @Input() public hasScanningAction: boolean;
  @Input() public hasCustomsAction: boolean;
  @Input() public hasWeighingAction: boolean;
  @Input() public weighingDone: number;
  @Input() public hasADRAction: boolean;
  @Input() public hasT1Action: boolean;
  @Input() public highValue: string;
  @Input() public temperature: string;
  @Input() public containerReleaseStatus: ContainerReleaseStatus;
  @Input() public hasTarTasCode: boolean;
  @Input() public hasContainerAvailable: number;
  @Input() public preAnnouncementStatus: number;
  @Input() public truckAppointmentStatus: number;
  @Input() public preAnnouncementError: string;
  @Input() public truckAppointmentError: string;
  @Input() public source: string;
  @Input() public hasConflicts: HasConflicts = HasConflicts.None;
  @Input() public requiresSideLoader: boolean;
  @Input() public requiresGenset: boolean;

  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;

  public user: ApplicationUser;
  public type = HasConflicts;
  public weighed: boolean;
  public weighIconStyle: string;
  public containerAvailableIconStyle: string;
  public containerReleaseStatusStyle: string = "action-icon--inactive";
  public preAnnouncement: any = { tooltip: "Pre-Announcement Not Required", style: "action-icon--inactive" };
  public truckAppointment: any = { tooltip: "Truck Appointment  Not Required", style: "action-icon--inactive" };
  public conflictColor: string = "";
  public selectedCheck: any = {
    showScanning: true,
    showCustom: true,
    showWeighing: true,
    showghingDone: true,
    showADR: true,
    showT1: true,
    showTemperature: false,
    showHighValue: false,
    showTarTasCode: true,
    showContainerAvailable: environment.containerPoolEnabled,
    showPreAnnouncementStatus: environment.tarTasEnabled,
    showTruckAppointmentStatus: environment.tarTasEnabled,
    showContainerReleaseStatus: true,
    showSideLoader: true,
    showGenset: true
  };
  containerReleaseStatusTooltip: string;

  public ngOnInit(): void {

    this.applicationUser$.subscribe((data) => {
      if (data) {
        this.user = data;
        if (this.source == ComponentSource.depotIn) {
          data.depotInGridIcons.forEach((el) => {
            if (!el) {
              return;
            }
            if (el.id == 1) {
              this.selectedCheck.showScanning = el.isVisible;
            } else if (el.id == 2) {
              this.selectedCheck.showCustom = el.isVisible;
            } else if (el.id == 3) {
              this.selectedCheck.showWeighing = el.isVisible;
            } else if (el.id == 4) {
              this.selectedCheck.showADR = el.isVisible;
            } else if (el.id == 5) {
              this.selectedCheck.showT1 = el.isVisible;
            } else if (el.id == 6) {
              this.selectedCheck.showContainerAvailable = el.isVisible && environment.containerPoolEnabled;
            } else if (el.id == 7) {
              this.selectedCheck.showTarTasCode = el.isVisible;
            } else if (el.id == 8) {
              this.selectedCheck.showPreAnnouncementStatus = el.isVisible && environment.tarTasEnabled;
            } else if (el.id == 9) {
              this.selectedCheck.showTruckAppointmentStatus = el.isVisible && environment.tarTasEnabled;
            } else if (el.id == 10) {
              this.selectedCheck.showTemperature = el.isVisible;
            } else if (el.id == 11) {
              this.selectedCheck.showHighValue = el.isVisible;
            } else if (el.id == 12) {
              this.selectedCheck.showContainerReleaseStatus = el.isVisible && environment.containerReleaseEnabled;
            } else if (el.id == 13) {
              this.selectedCheck.showSideLoader = el.isVisible;
            } else if (el.id == 14) {
              this.selectedCheck.showGenset = el.isVisible;
            }
          });
        } else if (this.source == ComponentSource.depotOut) {
          data.depotOutGridIcons.forEach((el) => {
            if (!el) {
              return;
            }
            if (el.id == 1) {
              this.selectedCheck.showScanning = el.isVisible;
            } else if (el.id == 2) {
              this.selectedCheck.showCustom = el.isVisible;
            } else if (el.id == 3) {
              this.selectedCheck.showWeighing = el.isVisible;
            } else if (el.id == 4) {
              this.selectedCheck.showADR = el.isVisible;
            } else if (el.id == 5) {
              this.selectedCheck.showT1 = el.isVisible;
            } else if (el.id == 6) {
              this.selectedCheck.showContainerAvailable = el.isVisible && environment.containerPoolEnabled;
            } else if (el.id == 7) {
              this.selectedCheck.showTarTasCode = el.isVisible;
            } else if (el.id == 8) {
              this.selectedCheck.showPreAnnouncementStatus = el.isVisible && environment.tarTasEnabled;
            } else if (el.id == 9) {
              this.selectedCheck.showTruckAppointmentStatus = el.isVisible && environment.tarTasEnabled;
            } else if (el.id == 10) {
              this.selectedCheck.showTemperature = el.isVisible;
            } else if (el.id == 11) {
              this.selectedCheck.showHighValue = el.isVisible;
            } else if (el.id == 12) {
              this.selectedCheck.showContainerReleaseStatus = el.isVisible && environment.containerReleaseEnabled;
            } else if (el.id == 13) {
              this.selectedCheck.showSideLoader = el.isVisible;
            } else if (el.id == 14) {
              this.selectedCheck.showGenset = el.isVisible;
            }
          });
        }

      }
    });

    this.setWeighingStyle();

    this.setContainerAvailableStyle();
    this.setConflictIconColor();
    this.setPreAnnouncementStyleAndTooltip();
    this.setTruckAppointmentStyleAndTooltip();
    this.setContainerReleaseStatusStyle();
  }

  setContainerAvailableStyle() {
    this.containerAvailableIconStyle = this.hasContainerAvailable === 0
      ? "action-icon--active"
      : (this.hasContainerAvailable === 3
        ? "action-icon--danger"
        : "action-icon--inactive");
  }

  setPreAnnouncementStyleAndTooltip() {
    this.preAnnouncement = {
      style: this.getStatusStyle(this.preAnnouncementStatus),
      tooltip: this.getPreAnnouncementTooltipKey(this.preAnnouncementStatus)
    };
  }

  getStatusStyle(status: number): string {
    switch (status) {
      case 2:
        return "action-icon--sent";
      case 3:
        return "action-icon--success";
      case 4:
        return "action-icon--danger";
      case 1:
      case 5:
        return "action-icon--warning";
      default:
        return "action-icon--inactive";
    }
  }

  getPreAnnouncementTooltipKey(status: number): string {
    switch (status) {
      case 1:
        return "ACTION_ICONS.TOOLTIPS.PRE_ANNOUNCEMENT.NOT_SENT";
      case 2:
        return "ACTION_ICONS.TOOLTIPS.PRE_ANNOUNCEMENT.SENT";
      case 3:
        return "ACTION_ICONS.TOOLTIPS.PRE_ANNOUNCEMENT.OK";
      case 4:
        return "ACTION_ICONS.TOOLTIPS.PRE_ANNOUNCEMENT.ERROR";
      case 5:
        return "ACTION_ICONS.TOOLTIPS.PRE_ANNOUNCEMENT.CANCELLED";
      default:
        return "ACTION_ICONS.TOOLTIPS.PRE_ANNOUNCEMENT.NOT_REQUIRED";
    }
  }

  getTruckAppointmentTooltipKey(status: number): string {
    switch (status) {
      case 1:
        return "ACTION_ICONS.TOOLTIPS.TRUCK_APPOINTMENT.NOT_SENT";
      case 2:
        return "ACTION_ICONS.TOOLTIPS.TRUCK_APPOINTMENT.SENT";
      case 3:
        return "ACTION_ICONS.TOOLTIPS.TRUCK_APPOINTMENT.OK";
      case 4:
        return "ACTION_ICONS.TOOLTIPS.TRUCK_APPOINTMENT.ERROR";
      case 5:
        return "ACTION_ICONS.TOOLTIPS.TRUCK_APPOINTMENT.CANCELLED";
      default:
        return "ACTION_ICONS.TOOLTIPS.TRUCK_APPOINTMENT.NOT_REQUIRED";
    }
  }

  setTruckAppointmentStyleAndTooltip() {
    this.truckAppointment = {
      style: this.getStatusStyle(this.truckAppointmentStatus),
      tooltip: this.getTruckAppointmentTooltipKey(this.truckAppointmentStatus)
    };
  }

  setWeighingStyle() {
    this.weighed = this.weighingDone === 1 ? true : false;
    this.weighIconStyle = this.hasWeighingAction
      ? (this.weighed ? "action-icon--active" : "action-icon--danger")
      : "action-icon--inactive";
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasWeighingAction) {
      this.setWeighingStyle();
    }
    if (changes.hasContainerAvailable) {
      this.setContainerAvailableStyle();
    }
    if (changes.preAnnouncementStatus) {
      this.setPreAnnouncementStyleAndTooltip();
    }
    if (changes.truckAppointmentStatus) {
      this.setTruckAppointmentStyleAndTooltip();
    }
    if (changes.containerReleaseStatus) {
      this.setContainerReleaseStatusStyle();
    }
  }


  setConflictIconColor() {
    if (this.hasConflicts == HasConflicts.None) {
      return "action-icon--inactive";
    }
    if (this.hasConflicts == HasConflicts.HasOnlyWarnings) {
      this.conflictColor = "action-icon--warning";
    } else if (this.hasConflicts == HasConflicts.HasErrors) {
      this.conflictColor = "action-icon--danger";
    } else {
      this.conflictColor = "action-icon--inactive";
    }
  }

  setContainerReleaseStatusStyle() {
    switch (this.containerReleaseStatus) {
      case ContainerReleaseStatus.NotRequired:
        this.containerReleaseStatusStyle = "action-icon--inactive";
        this.containerReleaseStatusTooltip = "Not Required";
        break;
      case ContainerReleaseStatus.Required:
        this.containerReleaseStatusStyle = "action-icon--warning";
        this.containerReleaseStatusTooltip = "Required";
        break;
      case ContainerReleaseStatus.Received:
      case ContainerReleaseStatus.UnassignDriverSuccess:
      case ContainerReleaseStatus.RevokeSuccess:
        this.containerReleaseStatusStyle = "action-icon--sent";
        this.containerReleaseStatusTooltip = "Received | Unassign Driver Success | Revoke Success";
        break;
      case ContainerReleaseStatus.Revoked:
      case ContainerReleaseStatus.AssignDriverFailed:
      case ContainerReleaseStatus.TransferFailed:
      case ContainerReleaseStatus.UnassignDriverFailed:
      case ContainerReleaseStatus.RevokeFailed:
        this.containerReleaseStatusStyle = "action-icon--danger";
        this.containerReleaseStatusTooltip = "Revoked | Assign Driver Failed | Transfer Failed | Unassign Driver Failed |  Revoke Failed";
        break;

      case ContainerReleaseStatus.AssignDriverSuccessful:
      case ContainerReleaseStatus.TransferSuccessful:
        this.containerReleaseStatusStyle = "action-icon--success";
        this.containerReleaseStatusTooltip = "Assign Driver Successful | Transfer Successful";
        break;

      default:
        this.containerReleaseStatusStyle = "action-icon--inactive";
        this.containerReleaseStatusTooltip = "";
        break;
    }
  }
}
